import { StyleSheet } from 'react-native';
import Theme from 'Theme';
import { Device } from 'DeviceUtils';
import dialogCommon from 'Theme/DialogCommon.jss';

const baseStyles = {
    ...dialogCommon,
    buttonContainer: {
        alignSelf: 'stretch',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column-reverse'
    },
    button: {
        margin: Theme.BU / 2
    }
};

if (Device.isTabletOrWeb) {
    baseStyles.buttonContainer.flexDirection = 'row';
    delete baseStyles.button.maxWidth;
}

export default StyleSheet.create(baseStyles);
